const blurryCornerCx = "bg-gradient-to-br via-transparent dark:via-transparent to-transparent dark:to-transparent";
export const toolkitCx = {
    // TODO: integrate https://github.com/SundaeSwap-finance/sundae-cardano-js/blob/main/packages/dapp-connector/src/connectors.ts#L8
    // TODO: add proper type for all available wallets and extract gradient map respectively
    gradients: {
        nami: "from-[#349ea3] to-[#fbd38d]",
        ccvault: "from-[#fe4e71] via-[#975dfe] to-[#51fcbb]",
        eternl: "from-[#fe4e71] via-[#975dfe] to-[#51fcbb]",
        gradientBackgroundColors: "from-secondary via-success to-primary",
    },
    layout: {
        background: {
            default: "bg-white dark:bg-gray-900",
            primary: "bg-primary",
            overlay: "bg-white/80 dark:bg-gray-900/80",
            secondary: "bg-gray-200/40 dark:bg-gray-800",
            arrowDialog: "fill-current text-gray dark:text-gray-600",
            card: "bg-gray dark:bg-gray-800",
            gradient: "bg-gradient-to-r from-secondary to-primary",
            hoverable: "hover:bg-gray-200 hover:dark:bg-gray-700",
            gradientHoverable: "hover:from-secondary-300 hover:to-primary-300",
            separator: "bg-gray-300 dark:bg-gray-600",
            tooltip: "bg-gray dark:bg-gray-600",
            loading: "bg-primary/10",
            muted: "bg-black/60 dark:bg-gray-200/60",
        },
        border: {
            active: "focus-within:border-primary-200/70 focus-within:border-primary-200/70",
            default: "border-gray-300 dark:border-gray-600",
            primary: "border-primary",
            secondary: "border-secondary",
            success: "border-success",
            warning: "border-warning-300",
            muted: "border-black/60 dark:border-gray-200/60",
            silent: "border-black/40 dark:border-gray-200/40",
            error: "border-error",
            hoverable: "hover:border-primary-200/50 dark:hover:border-primary-200/50",
            flashOnFocus: "relative before:pointer-events-none before:absolute before:inset-0 before:rounded-lg motion-safe:focus-within:before:animate-shadow-pulse",
            weight: {
                default: "border",
                semibold: "border-2",
                bold: "border-4",
            },
        },
        spacing: {
            horizontal: {
                xs: "px-1",
                sm: "px-2",
                md: "px-4",
                lg: "px-6",
                xl: "px-8",
            },
            vertical: {
                xs: "py-1",
                sm: "py-2",
                md: "py-4",
                lg: "py-6",
                xl: "py-8",
            },
            both: {
                xs: "p-1",
                sm: "p-2",
                md: "p-4",
                lg: "p-6",
                xl: "p-8",
            },
            left: {
                xs: "pl-1",
                sm: "pl-2",
                md: "pl-4",
                lg: "pl-6",
                xl: "pl-8",
            },
            right: {
                xs: "pr-1",
                sm: "pr-2",
                md: "pr-4",
                lg: "pr-6",
                xl: "pr-8",
            },
            top: {
                xs: "pt-1",
                sm: "pt-2",
                md: "pt-4",
                lg: "pt-6",
                xl: "pt-8",
            },
            bottom: {
                xs: "pb-1",
                sm: "pb-2",
                md: "pb-4",
                lg: "pb-6",
                xl: "pb-8",
            },
        },
        sizes: {
            height: {
                xs: "h-7",
                sm: "h-8",
                md: "h-9",
                lg: "h-11",
                xl: "h-12",
            },
            width: {
                xs: "w-7",
                sm: "w-8",
                md: "w-9",
                lg: "w-11",
                xl: "w-12",
            },
            both: {
                xs: "w-7 h-7",
                sm: "w-8 h-8",
                md: "w-9 h-9",
                lg: "w-11 h-11",
                xl: "w-12 h-12",
            },
        },
        shadow: {
            default: "shadow-lg",
            dialog: "shadow-lg dark:shadow-xl dark:shadow-gray-900/10",
        },
        text: {
            default: "text-black dark:text-gray-200",
            primary: "text-primary",
            silent: "text-black/40 dark:text-gray-200/40",
            muted: "text-black/60 dark:text-gray-200/60",
            light: "text-white",
            dark: "text-black",
            error: "text-error dark:text-error",
            warning: "text-warning-300",
            success: "text-success",
            info: "text-primary",
            current: "text-current",
            secondary: "text-secondary",
        },
        textSize: {
            "2xs": "text-xxs",
            xs: "text-xs",
            sm: "text-sm",
            base: "text-base",
            lg: "text-lg",
            xl: "text-xl",
            "2xl": "text-2xl",
            "3xl": "text-3xl",
            "4xl": "text-4xl",
            "5xl": "text-5xl",
            "6xl": "text-6xl",
            "7xl": "text-7xl",
        },
        size: {
            "2xs": "w-1 h-1",
            xs: "w-2 h-2",
            sm: "w-3 h-3",
            base: "w-4 h-4",
            lg: "w-6 h-6",
            xl: "w-8 h-8",
            "2xl": "w-12 h-12",
            "3xl": "w-16 h-16",
            "4xl": "w-20 h-20",
            "5xl": "w-24 h-24",
            "6xl": "w-28 h-28",
            "7xl": "w-32 h-32",
        },
        transition: {
            default: "transition duration-300",
            all: "transition-all duration-300",
            colors: "transition-colors duration-300",
            opacity: "transition-opacity duration-300",
            shadow: "transition-shadow duration-300",
            transform: "transition-transform duration-300",
        },
        width: {
            widget: "w-full md:max-w-[28rem] lg:max-w-[31rem]",
        },
    },
    recipes: {
        /** @deprecated
         * Use `blurryCorner` instead.
         *
         * Possible variants: `error` | `success` | `primary` | `warning`
         *
         * @example
         * <div className={toolkitCx.recipes.blurryCorner.primary}>…</div>
         */
        blurryShadow: `${blurryCornerCx} before:bg-primary/10 dark:before:bg-primary/5`,
        blurryCorner: {
            error: `${blurryCornerCx} from-error/20 dark:from-error/10`,
            primary: `${blurryCornerCx} from-primary/20 dark:from-primary/10`,
            secondary: `${blurryCornerCx} from-secondary/20 dark:from-secondary/10`,
            success: `${blurryCornerCx} from-success/30 dark:from-success/20`,
            warning: `${blurryCornerCx} from-warning/20 dark:from-warning/10`,
            errorSubtle: `${blurryCornerCx} from-error/10 dark:from-error/5`,
            primarySubtle: `${blurryCornerCx} from-primary/10 dark:from-primary/5`,
            secondarySubtle: `${blurryCornerCx} from-secondary/10 dark:from-secondary/5`,
            successSubtle: `${blurryCornerCx} from-success/20 dark:from-success/10`,
            warningSubtle: `${blurryCornerCx} from-warning/10 dark:from-warning/5`,
        },
        center: {
            horizontal: "left-1/2 -translate-x-1/2",
            vertical: "top-1/2 -translate-y-1/2",
            both: (prefix = "") => `${prefix}right-1/2 ${prefix}translate-x-1/2 ${prefix}bottom-1/2 ${prefix}translate-y-1/2`,
        },
        dialogWidth: "min-w-[15rem] max-w-sm",
        scaleWhenActive: "active:scale-[0.975]",
        tooltipHover: "transition-opacity duration-300 hover:opacity-75",
    },
};
//# sourceMappingURL=classnames.js.map